import { render } from "./setHome.vue?vue&type=template&id=0961db6e&scoped=true&ts=true"
import script from "./setHome.vue?vue&type=script&lang=ts"
export * from "./setHome.vue?vue&type=script&lang=ts"

import "./setHome.vue?vue&type=style&index=0&id=0961db6e&lang=scss&scoped=true"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0961db6e"]])

export default __exports__